import { BackedApi } from "../../../../config/urls/Api";
import { User } from "../../../../models/user";

interface ResponseCreateUser {
    data: User | any;
    error: boolean;
}

export class SignupRepository {
    static async createUser(user: User, token: string, planId?: string): Promise<ResponseCreateUser> {
        const body = { ...user, token, ...(planId && { plan: planId }) }
        const response = await this.sendRequest(
            BackedApi.CreateUser.url,
            BackedApi.CreateUser.method,
            body
        )
        const data = await response.json();
        const status = response.status;
        return { data, error: status !== 201 };
    }

    private static async sendRequest(url: string, method: string, body: any) {
        const response = await fetch(url, {
            method,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })
        return response;
    }
}